import { html } from "../../render";
import { attr, cn, spreadAttrs } from "../../utils";
export const LP_LAYER_CARD_PADDING = ["none", "base"];
const layerCardManagedAttrs = [
    "data-lp-component",
    "class",
];
const layerCardSurfaceManagedAttrs = [
    ...layerCardManagedAttrs,
    "data-padding",
];
const layerCardSectionManagedAttrs = [
    "class",
    "data-lp-layer-card-section",
    "data-padding",
];
export function LpLayerCard({ children, className, attributes, }) {
    return html `
        <div
            data-lp-component="LayerCard"
            class="${cn("lp-layer-card", className, attributes?.class)}"
            ${spreadAttrs(attributes, { omit: layerCardManagedAttrs })}
        >
            ${children}
        </div>
    `;
}
export function LpLayerCardSurface({ children, padding = "none", className, attributes, }) {
    return html `
        <div
            data-lp-component="LayerCardSurface"
            class="${cn("lp-layer-card_surface", className, attributes?.class)}"
            data-padding="${padding}"
            ${spreadAttrs(attributes, { omit: layerCardSurfaceManagedAttrs })}
        >
            ${children}
        </div>
    `;
}
export function LpLayerCardSecondary({ children, className, attributes, }) {
    return html `
        <div
            class="${cn("lp-layer-card_secondary", className, attributes?.class)}"
            data-lp-layer-card-section="secondary"
            ${spreadAttrs(attributes, { omit: layerCardSectionManagedAttrs })}
        >
            ${children}
        </div>
    `;
}
export function LpLayerCardPrimary({ children, padding = "base", className, attributes, }) {
    return html `
        <div
            class="${cn("lp-layer-card_primary", className, attributes?.class)}"
            data-lp-layer-card-section="primary"
            data-padding="${padding}"
            ${spreadAttrs(attributes, { omit: layerCardSectionManagedAttrs })}
        >
            ${children}
        </div>
    `;
}
